export const DEFAULT_CURRENCY = 'EUR';

export enum CacheStaleTime {
  FIVE_MINUTES = 300_000,
  TEN_MINUTES = 600_000,
  ONE_HOUR = 3_600_000,
  ONE_DAY = 86_400_000,
  ONE_MINUTE = 60_000,
  INFINITE = Infinity,
}
